import { render, staticRenderFns } from "./FileAddFormModal.vue?vue&type=template&id=af2914cc"
import script from "./FileAddFormModal.vue?vue&type=script&lang=js"
export * from "./FileAddFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports